import React from "react";
import styled from "styled-components";
import { displayValueOrNA } from "./assets/utils";

const Description = (fetchedData: any) => {
  const details = fetchedData?.fetchedData?.data?.[0];
  return (
    <GlobalContainer>
      <h1>Description</h1>
      <p>{displayValueOrNA(details?.description)}</p>
    </GlobalContainer>
  );
};

export default Description;
export const GlobalContainer = styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 10px;
  gap: 5px;
  background: #fff;
  box-shadow: 0 1px 7.8px 0 rgba(22, 71, 129, 0.05);
  h1 {
    color: #090b0e;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  p {
    color: var(--Grey-02, #3d4c5e);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    align-self: stretch;
  }
`;
